import { apiFetch } from './client'

/**
 * s67 / ADR-0033 2i (R2 + J1, Marcelo 25/10/2026 14:46) -- pessoas para a BUSCA NO TOPO.
 *
 * Le `GET /api/employees` (projecao `EmployeePublicSummary`: sem CPF, sem salario, sem endereco, sem contatos -- ADR-0014
 * D9). So o NOME e o rotulo do cargo vao para a tela. Quem chama (TopSearch) so liga esta leitura para quem PODE VER NOME
 * de pessoa no assistente (`assistant.person_topics`) e com a IA ligada -- sem isso a chamada NAO acontece (guarda J1).
 * Nada vai para o navegador: vive so no cache do React Query, que "Sair" e a troca de empresa apagam.
 */
export interface PersonOption {
  id: string
  name: string
  positionLabel: string | null
}

interface EmployeeSummaryResponse {
  id: string
  display_name?: string | null
  name?: string | null
  position_label?: string | null
  status?: string | null
}

export const PEOPLE_PAGE_SIZE = 200
export const PEOPLE_MAX_PAGES = 20
export const PEOPLE_QUERY_KEY = ['people', 'search'] as const
/** A mesma permissao que deixa o assistente responder sobre PESSOAS (s64 / 2d). */
export const PERSON_TOPICS_PERMISSION = 'assistant.person_topics'

export async function fetchAllPeople(): Promise<PersonOption[]> {
  const todos: PersonOption[] = []
  for (let pagina = 0; pagina < PEOPLE_MAX_PAGES; pagina++) {
    const itens = await apiFetch<EmployeeSummaryResponse[]>(
      `/api/employees?limit=${PEOPLE_PAGE_SIZE}&offset=${pagina * PEOPLE_PAGE_SIZE}`,
    )
    for (const e of itens) {
      const nome = (e.display_name ?? e.name ?? '').trim()
      // so ATIVOS: afastado e anonimizado nao aparecem na busca (o anonimizado so tem token no lugar do nome)
      if (nome && e.status === 'active') todos.push({ id: e.id, name: nome, positionLabel: e.position_label ?? null })
    }
    if (itens.length < PEOPLE_PAGE_SIZE) return todos
  }
  return todos
}
